module.exports = __webpack_public_path__ + "static/img/30.ce9684b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/30.png
// module id = Rmw/
// module chunks = 0